module.exports = __webpack_public_path__ + "static/img/Refresh.04977d02.svg";